import React, { Component } from 'react';
import * as bActs from '../actions/blog-actions';
import * as wActs from '../actions/website-actions';
import {Link} from 'react-router-dom'
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/SeoHeaders";
import { FormattedDate } from 'react-intl';
import Pager from "../components/pager";
import EPomBanner from "../components/epombanner";
import * as wConsts from "../consts/website-consts";
import SwBanner from "../components/swbanner";
import BuyAdsBanner from "../components/buyadsbanner";

class BlogList extends Component {

  componentDidMount() {
    //this.props.dispatch(bActs.GetBlogPosts());
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "bloglist" });
  }


  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }


  render() {
    let loc = typeof window === "undefined" ? "" : window.location.href;
    let blogList = () => {
      return (
        <p style={{display: "flex", alignContent: "center", justifyContent: "center" }}>
          <img src={`/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/loader.gif?v=13`} width={"100px"} height={"100px"} alt={"Loading"} />
        </p>
      );
    };

    if(this.props.Loaded && this.props.Code === 200) {
      blogList = () => {
        //console.log(this.props);
        return this.props.Posts.map((v,i) => {
          const bLink = wActs.getCultPath(this.props.WebPage,this.props.WebPage.Settings.BlogPath + "/" + v.Slug);
          return (

            <div key={"blog-entry-" + i} className="post-wrapper">
              <Link to={bLink}>{v.Title}</Link>
              <ul className="date">
                <li><FormattedDate value={v.PublishedDate} weekday="long" day="2-digit" month="long" year="numeric"  /></li>
                <li>&nbsp;&nbsp;{v.Author.Name}</li>
              </ul>
              <div className="post-cover">
                {bActs.showImage(v.Image.Width, v.Image.Height) &&
                  <Link to={bLink}>
                    <img src={v.Image.Url} alt={v.Image.Title}/>
                  </Link>
                }
              </div>
              <div className="post-description">
                <p>{v.Summary}</p>
                <div className="read-more">
                  <Link to={bLink}>Read more</Link>
                </div>
              </div>
              <div className="post-info">
                <ul>
                  <li className="post-share">Share:
                    <a href={"https://www.facebook.com/sharer/sharer.php?u=" + escape(loc)} target={"_blank"}><i className="fa fa-facebook" aria-hidden="true"></i></a>
                    <a href={"https://twitter.com/home?status=" + escape(loc)} target={"_blank"}><i className="fa fa-twitter" aria-hidden="true"></i></a>
                  </li>
                  <li className="post-categorie">Categories: {v.Categories.map((cv,i) => { return <span key={"cat-" + i} style={{margin: "2px"}}>{cv.Name}</span>})}</li>
                </ul>
              </div>
            </div>
          );
        });
      }
    }



    return (
      <div className="blog-wrapper">

        <div className="container">
          <div className="row">
            <div className="col-sm-8">
              {blogList()}
            </div>

            <div className="col-sm-4">
              <div className="promo-sidebar">
                <div className="flex-center-vertical">
                  <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId} tagText={this.props.WebPage.Settings.HtmlSections['Adserver-200x333-featured']} className="opartners-list">
                    <BuyAdsBanner size="200x333" textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
                  </SwBanner>
                </div>
                <div className="flex-center-vertical">
                  <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId} tagText={this.props.WebPage.Settings.HtmlSections['Adserver-200x200-featured']} className="opartners-list" >
                    <BuyAdsBanner size="200x200" textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
                  </SwBanner>
                </div>
                <div className="flex-center-vertical">
                  <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId} tagText={this.props.WebPage.Settings.HtmlSections['Adserver-200x333-sidebar']} className="opartners-list" >
                    <BuyAdsBanner size="200x333" textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
                  </SwBanner>
                </div>
                <div className="flex-center-vertical">
                  <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId} tagText={this.props.WebPage.Settings.HtmlSections['Adserver-200x200-sidebar']} className="opartners-list" >
                    <BuyAdsBanner size="200x200" textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
                  </SwBanner>
                </div>

              </div>
            </div>



          </div>
          {this.props.Loaded && this.props.Code === 200 &&
            <div className="row">
              <Pager ShowPages={3} Page={this.props.BlogList.Result.Context.Page} TotalPages={this.props.BlogList.Result.Context.TotalPages} />
            </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    MainContent: state.Website.Page.Content.Main,
    WebPage: state.Website,
    BlogList: state.Blog.BlogList,
    Posts: state.Blog.BlogList.Result.Result,
    Loaded: state.Blog.BlogList.Loaded,
    Code: state.Blog.BlogList.Result.Code,
  };
}

export default connect(mapStateToProps)(BlogList);
